import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120,
        zIndex: 99
    },
    marginContainer: {
        marginBottom: 20
    },
    contentContainer: {
        flex: 1
    },
    scrollContent: {
        flexGrow: 1
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
